@switch (true) {

@case(showCompanyList){

<div class="stock-wrapper other-store">
  @if(selectedArea){
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleGoBackToAreaList.emit()">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedArea}}&nbsp;/&nbsp;{{"COMPANIES"|translate}}</span>
  </div>
  }@else {
  <div class="stock-row title">
    <span>{{"COMPANIES"|translate}}</span>
  </div>
  }

  @if(!companies()){

  <app-placeholder [message]="'No company available' | translate"></app-placeholder>

  }@else {

  <div class="stores placeholder-glow">

    @if(companies()!.length === 0 ){

    <div class="spinner-wrapper">
      <div class="spinner-border text-primary mx-auto" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    }

    @for(company of companies(); track company.code){
    @if(company.storeStocks === undefined){
    <app-stock-button [text]="company.name" [counters]="company.stockCounters"
      [placeholder]="company.storeStocks === undefined" (handleClick)="handleSelectCompany(company)"></app-stock-button>
    }@else {
    <app-stock-button [text]="company.name" [counters]="company.stockCounters"
      [placeholder]="company.storeStocks === undefined" (handleClick)="handleSelectCompany(company)"></app-stock-button>
    }
    }

  </div>
  }

</div>

}

@case(showStoreList){

<div class="stock-wrapper other-store">
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleSelectCompany(null)">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedCompany()?.name}}&nbsp;/&nbsp;{{"STORES"|translate}}</span>
  </div>

  @if(stores().length === 0){

  <app-placeholder [message]="'No stock available for company:' | translate">
    <b>{{selectedCompany()?.name}}</b>
  </app-placeholder>

  }@else {

  <div class="stores placeholder-glow">

    @if(companies()!.length === 0 ){

    <div class="spinner-wrapper">
      <div class="spinner-border text-primary mx-auto" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    }

    @for(store of stores(); track store.idStore){
    <app-stock-button [text]="store.storeName + ' - ' + store.store"
      [counters]="stockAndPriceService.getStockCounters(store)"
      (handleClick)="handleSelectStore(store)"></app-stock-button>
    }

  </div>

  }

</div>


@if(stores().length > 0){
<app-stock-button class="total" [text]="'TOTAL'|translate" [counters]="total()" [isTotal]="true"></app-stock-button>
}

}

@case (showStoreStock) {
<div class="stock-wrapper other-store">
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleSelectStore(null)">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedCompany()?.name}}&nbsp;/&nbsp;{{selectedStore()?.storeName}}&nbsp;-&nbsp;{{selectedStore()?.store}}</span>
  </div>
</div>

@if(selectedStore()){
<app-my-store-stock [storeStock]="selectedStore"></app-my-store-stock>
}

}

}
